import ElasticSearch from 'elasticsearch-browser'
import { getParam } from '../../helpers/parameters'
import * as KEYS from '../../constants/keys'

const luceneEscape = (str) =>
  str.replace(/([!\/\*\+&\|\(\)\[\]\{\}\^~\?:"])/g, '\\$1')

export const buildQuery = (query) => {
  query = query.replace(/\//g, ' ')
  const queryObject = {
    query: {
      bool: {
        disable_coord: true,
        should: [
          {
            function_score: {
              query: {
                bool: {
                  should: [
                    {
                      constant_score: {
                        filter: { match: { classification_language_1: query } },
                        boost: 3
                      }
                    },
                    {
                      function_score: {
                        query: { match_phrase: { heading_language_1: query } },
                        boost: 2
                      }
                    },
                    { match: { device: query } },
                    { match: { name: query } }
                  ]
                }
              },
              boost: 12
            }
          },
          { term: { device: 'general' } },
          {
            query_string: {
              query,
              default_field: 'heading_language_1',
              minimum_should_match: '95%',
              boost: 6
            }
          },
          {
            query_string: {
              query,
              default_field: 'heading_language_1',
              minimum_should_match: '2',
              boost: 4
            }
          },
          {
            query_string: {
              query,
              default_field: 'heading_language_1',
              boost: 2
            }
          }
        ],
        must: [
          {
            match: {
              all_content_language_1: {
                query,
                minimum_should_match: '3<-75% 9<-85%'
              }
            }
          }
        ],
        filter: {
          bool: {
            must: [
              { term: { deleted: 0 } },
              {
                bool: {
                  should: [
                    { term: { type: 'faq' } },
                    { term: { type: 'tutorial' } }
                  ]
                }
              }
            ]
          }
        }
      }
    },

    stored_fields: ['heading_language_1', 'description_language_1'],
    collapse: { field: 'pk' },
    highlight: buildHighlightQuery(query)
  }

  return queryObject
}

export const buildSuggestionQuery = (query, options = {}) => {
  query = luceneEscape(query)
  return {
    size: 0,
    query: {
      bool: {
        must: [
          {
            multi_match: {
              query,
              fields: [
                'phrase_starts_with_language_1^1.75',
                'heading_bigrams_1',
                'term_starts_with_language_1'
              ],
              minimum_should_match: '4<-85% 6<-95%',
              fuzziness: options.fuzziness ? 'AUTO' : undefined
            }
          }
        ],
        filter: { term: { deleted: 0 } }
      }
    },
    aggs: {
      headings: {
        terms: {
          field: 'suggestion_language_1',
          order: { max_score: 'desc' }
        },
        aggs: {
          max_score: {
            max: {
              script: {
                lang: 'painless',
                inline: '_score'
              }
            }
          }
        }
      }
    }
  }
}

export const buildHighlightQuery = (query) => ({
  fields: {
    heading_language_1: { number_of_fragments: 0 },
    description_language_1: {
      highlight_query: {
        query_string: {
          fields: ['description_language_1'],
          query: luceneEscape(query)
        }
      }
    }
  }
})

export const client = async (path) => {
  const careassistApiUrl = await getParam('careassistApiUrl')
  const token = localStorage.getItem(KEYS.JWT_TOKEN)
  const url = new URL(careassistApiUrl)

  const ESLogger = class ESLogger {
    constructor() {}

    trace() {}
    error() {}
    warning() {}
    info() {}
    debug() {}
  }
  return new ElasticSearch.Client({
    log: ESLogger,
    host: {
      host: url.hostname,
      protocol: url.protocol,
      port: url.port || (url.protocol.includes('https') ? '443' : '80'),
      path: `${url.pathname.replace(/\/$/, '')}/${path}`,
      headers: { Authorization: `Bearer ${token}` }
    }
  })
}
